import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails, GetAffiliateLiquidationDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetAffiliateLiquidationCommand extends IRequestCommand<
  IGetAffiliateLiquidationResponse,
  ErrorDetails,
  IGetAffiliateLiquidationCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl =
    'affiCheckingAccount/{checkingAccId}/liquidation/{liquidationId}?';

  public override setParameters(parameters: IGetAffiliateLiquidationCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{checkingAccId}',
      parameters.checkingAccountId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{liquidationId}',
      parameters.liquidationId.toString()
    );
    this._commandUrl = this._commandUrl.concat(
      parameters.affiliateId && parameters.affiliateId.toString().length > 0
        ? `affiliateId=${parameters.affiliateId}`
        : ''
    );
    this._commandUrl = this._commandUrl.concat(
      parameters.page && parameters.page.toString().length > 0
        ? `&page=${parameters.page}`
        : ''
    );
    this._commandUrl = this._commandUrl.concat(
      parameters.size && parameters.size.toString().length > 0
        ? `&size=${parameters.size}`
        : ''
    );
    this._commandUrl = this._commandUrl.concat(
      parameters.column && parameters.column.toString().length > 0
        ? `&column=${parameters.column}`
        : ''
    );
    this._commandUrl = this._commandUrl.concat(
      parameters.sort && parameters.sort.toString().length > 0
        ? `&sort=${parameters.sort}`
        : ''
    );
  }
}

export interface IGetAffiliateLiquidationCommandParameters
  extends ICommandResponse {
  checkingAccountId: number;
  liquidationId: number;
  affiliateId: number;
  column?: string;
  page?: number;
  size?: number;
  sort?: string;
}

export interface IGetAffiliateLiquidationResponse
  extends ICommandResponse,
    GetAffiliateLiquidationDTO {}
